/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuctionStatsDto } from '../../models/auction-stats-dto';

export interface GetAuctionStats$Params {
  id: number;
  'X-API-Version'?: string;
}

export function getAuctionStats(http: HttpClient, rootUrl: string, params: GetAuctionStats$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionStatsDto>> {
  const rb = new RequestBuilder(rootUrl, getAuctionStats.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuctionStatsDto>;
    })
  );
}

getAuctionStats.PATH = '/api/auctions/{id}/stats';
